<div class="bn-event-logs-toolbar">
  <div class="bn-event-logs-toolbar__controls">
    <span class="d-flex w-100 justify-content-between justify-content-md-start">
      <span class="d-flex">
        <bn-web-ui-datepicker
          class="bn-event-logs-toolbar__date"
          data-e2e="EventLogsDateRangeInput"
          itemStyle="secondary"
          size="xxs"
          type="range"
          [bsConfig]="datePickerConfig()"
          [ngModel]="datePickerRange()"
          [options]="{
            minWidth: '120px',
            type: 'range',
          }"
          [readonly]="isLoading()"
          (ngModelChange)="onRangeChange($event)" />
      </span>
      <span class="d-flex">
        <app-app-shield-event-logs-group-by
          class="ms-2"
          [groupByDims]="groupByDims()"
          (groupByChange)="groupByChange.emit($event)" />

        <bn-web-ui-filter-chips
          class="ms-1 ms-xl-2"
          [config]="chipsConfig()"
          [value]="chipsValue()"
          (valueChange)="filtersChange.emit($event)" />

        <button
          bn-web-ui-button
          buttonStyle="rounded"
          class="bn-event-logs-toolbar__export-button ms-1 ms-xl-2"
          data-e2e="ExportEventLogsCsvButton"
          itemStyle="stroke"
          size="sm"
          type="button"
          [disabled]="!hasLogs()"
          [lessPadding]="true"
          [loading]="isExporting()"
          (click)="exportClicked.emit()">
          <fa-icon
            class="me-0 me-xl-1"
            icon="download" /><span class="d-none d-xl-inline-block">Export CSV</span>
        </button>
      </span>
    </span>
    <span class="bn-event-logs-toolbar__right d-flex align-items-center justify-content-center mt-2 mt-md-0">
      <bn-web-ui-input
        class="bn-event-logs-toolbar__search me-1 me-xl-2 ms-md-2 w-100"
        containerExtraClass="border-dark-3"
        data-e2e="EventLogsSearchInput"
        itemStyle="primary"
        placeholder="Search"
        size="xxs"
        [ngModel]="queryValue()"
        [options]="{ rightAddons: [{ icon: 'magnifying-glass', size: 'sm' }], isRounded: true }"
        (ngModelChange)="onQueryChange($event)" />

      <bn-web-ui-button
        aria-label="Refresh"
        class="bn-event-logs-toolbar__refresh bn-button--circle flex-shrink-0"
        data-e2e="RefreshEventLogsButton"
        itemStyle="stroke"
        size="sm"
        type="button"
        [loading]="isLoading()"
        (click)="refreshClicked.emit()">
        <fa-icon
          containerClass="m-1"
          icon="arrows-rotate" />
      </bn-web-ui-button>
    </span>
  </div>
</div>
